// Pure helpers for the browser-side image pipeline. Kept free of canvas and
// createImageBitmap so they are testable under jsdom -- and so the Django admin
// copy in medias/static/medias/image-upload.js has an exact spec to mirror.

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

// Matches MAX_IMAGE_SIZE in medias/s3_utils.py.
export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024;

export function isAllowedImageType(type) {
    return ALLOWED_IMAGE_TYPES.includes(type);
}

// Scale so the LONG edge lands on maxEdge. createImageBitmap's resizeWidth
// option only sets the width -- a 1000x3000 portrait would come back 3000px
// tall -- so the caller passes these numbers to drawImage instead.
export function computeTargetSize(width, height, maxEdge) {
    if (!(width > 0) || !(height > 0)) {
        throw new Error(
            `Image dimensions must be positive, got ${width}x${height}`,
        );
    }

    const longest = Math.max(width, height);
    if (longest <= maxEdge) {
        return { width, height }; // never upscale
    }

    const scale = maxEdge / longest;
    return {
        width: Math.max(1, Math.round(width * scale)),
        height: Math.max(1, Math.round(height * scale)),
    };
}
